import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './utils/request.js' // 引入封装的 http 文件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
export const EventBus = new Vue()

// mixins
import '@/mixins/index'

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
	store,  // 注入store
	router,  // 注入路由
	render: h => h(App),
}).$mount('#app')
